import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UsersStoreProvider } from '../users-store/users-store';
import { LocationStoreProvider } from '../location-store/location-store';
import { CategoriesStoreProvider } from '../categories-store/categories-store';
import { RoomsStoreProvider } from '../rooms-store/rooms-store';
import { removePTags, formatDate } from '../../Utils/CommonUtils';
import { Tasks } from '../../Interface/CommonDataBaseInterface';
import { ConfigDataProvider } from '../config-data/config-data';
import { ConnectionProvider } from '../connection/connection';
@Injectable()
export class TasksStoreProvider {

	public db = new DatabaseProvider();
	public tasksList: BehaviorSubject<any> = new BehaviorSubject([]);
	public taskTypeList: BehaviorSubject<any> = new BehaviorSubject([]);
	public syncTasksObservable$: BehaviorSubject<any> = new BehaviorSubject(false);
	public showSyncTasksError$: BehaviorSubject<any> = new BehaviorSubject(false);

	private userList = [];
	private locationList = [];
	private categoriesList = [];
	private roomsList = [];

	constructor(
		private usersStore: UsersStoreProvider,
		private loactionStore: LocationStoreProvider,
		private categoriesStore: CategoriesStoreProvider,
		private roomsStore: RoomsStoreProvider,
		private configDataPrvdr: ConfigDataProvider,
		private connection: ConnectionProvider
	) {
		this.usersStore.usersList
			.subscribe((list) => {
				this.userList = [...list];
			})
		this.usersStore.loadList().then(() => { }).catch((e) => { });

		this.loactionStore.locationList
			.subscribe((list) => {
				this.locationList = [...list];
			})
		this.loactionStore.loadList().then(() => { }).catch((e) => { });

		this.categoriesStore.categoriesList
			.subscribe((list) => {
				this.categoriesList = [...list];
			})

		this.categoriesStore.loadList().then(() => { }).catch((e) => { });
		this.roomsStore.roomsList
			.subscribe((list) => {
				this.roomsList = [...list];
			})
		this.roomsStore.loadList().then(() => { }).catch((e) => { });

		this.loadTaskTypeList().then(() => { }).catch(() => { })
	}

	addBatch(tasksList) {

		return new Promise((resolve, reject) => {

			this.db.tasks.clear().then(() => {

				tasksList.forEach((tmpMessage) => {
					tmpMessage.appstatus = "";
				})

				this.db.tasks.bulkAdd(tasksList).then((data) => {
					resolve(data)
				}).catch((e) => {
					reject(e);
				})

			}).catch((e) => {
				reject(e);
			})

		})

	}

	loadTasksList() {

		return new Promise((resolve, reject) => {

			this.db.tasks.toArray().then((list) => {

				list = this.manipulateTasksList(list);
				this.tasksList.next(list);

				resolve(true);

			}).catch((e) => reject(e))

		})

	}

	addToTaskTypes(taskTypeList) {

		return new Promise((resolve, reject) => {

			this.db.werkbonType.clear().then(() => {

				this.db.werkbonType.bulkAdd(taskTypeList).then((data) => {

					this.loadTaskTypeList();
					resolve(data);

				}).catch((e) => reject(e))

			}).catch((e) => reject(e))

		})

	}

	loadTaskTypeList() {

		return new Promise((resolve, reject) => {

			this.db.werkbonType.toArray().then((list) => {

				this.taskTypeList.next(list);

			}).catch((e) => reject(e))

		})

	}

	manipulateTasksList(list) {


		var userList = [];
		var werkbontypesList = [];
		// var categoriesList = [];
		// var roomsList = [];
		var afdelingenList = [];
		let werkbonnen = [];

		userList = this.userList;
		werkbontypesList = this.taskTypeList.getValue();
		afdelingenList = this.locationList;

		if (list && list.length > 0) {

			list.forEach(function (value) {

				var fnameData = userList.filter((function (user) {
					return value.senderuserid == user.id
				}))
				var executorData = userList.filter((function (user) {
					return value.userexecuted == user.id
				}))
				var workBonTypeData = werkbontypesList.filter((function (wt) {
					return value.werkbontype == wt.id
				}))
				var afdelingenData = afdelingenList.filter((function (a) {
					return value.afdeling == a.id
				}))

				// var categorieData = categoriesList.filter((function (wc) {
				//     return value.categorie == wc.id
				// }))
				// var roomsData = roomsList.filter((function (k) {
				//     return value.kamer == k.id
				// }))

				let upic = "";

				if (fnameData.length > 0 && fnameData[0].picture != '' && fnameData[0].picture != null) {
					// if ((!ionic.Platform.isAndroid() && !ionic.Platform.isIOS() && !ionic.Platform.isIPad()))
					// 	upic = fnameData[0].picture;
					// else{
					// 	if(cordova.platformId == "browser"){
					// 		upic = fnameData[0].picture;
					// 	}else {
					// 		upic = toolsService.getFilePath(fnameData[0].picture);
					// 	}
					// }

					upic = fnameData[0].picture;
				}
				else {
					upic = './assets/imgs/avatar.jpg';
				}
				var werkbonseq = value.werkbonseq;
				if (value.werkbonseq == null) {
					werkbonseq = 'Klaar om te versturen';
				}
				var werkbon = {
					customercode: value.customercode,
					id: value.id,
					fname: (fnameData.length > 0) ? fnameData[0].fname : "",
					userpicture: upic,
					werkbonseq: werkbonseq,
					werkbontype: (workBonTypeData.length > 0) ? workBonTypeData[0].name : "",
					werkbontypeId : (workBonTypeData.length > 0) ? workBonTypeData[0].id : "",
					datecreated: value.datecreated,
					afdeling: (afdelingenData.length > 0) ? afdelingenData[0].name : "",
				}
				werkbon['classname'] = 'item werkbonitem';

				if (value.status == '1') {
					werkbon['classname'] += ' done';
				}
				else {
					werkbon['classname'] += ' new';
				}

				werkbonnen.push(werkbon);
			})

			werkbonnen = werkbonnen.sort(function (d1, d2) {
				let t1 = d1.datecreated.toString().replace(" ", "T");
				let t2 = d2.datecreated.toString().replace(" ", "T");
				return new Date(t2).getTime() - new Date(t1).getTime();
			});

		}

		return werkbonnen;

	}

	getTask(taskId) {

		var userList = [];
		var werkbontypesList = [];
		var categoriesList = [];
		var roomsList = [];
		var afdelingenList = [];

		userList = this.userList;

		werkbontypesList = this.taskTypeList.getValue();;
		afdelingenList = this.locationList;
		categoriesList = this.categoriesList
		roomsList = this.roomsList;

		return new Promise((resolve, reject) => {

			this.db.tasks.where({ id: taskId }).toArray().then((data) => {

				let workBonData = data;

				if (workBonData.length > 0) {

					var fnameData = userList.filter((function (user) {
						return workBonData[0].senderuserid == user.id
					}))
					var executorData = userList.filter((function (user) {
						return workBonData[0].userexecuted == user.id
					}))
					var workBonTypeData = werkbontypesList.filter((function (wt) {
						return workBonData[0].werkbontype == wt.id
					}))
					var afdelingenData = afdelingenList.filter((function (a) {
						return workBonData[0].afdeling == a.id
					}))

					var categorieData = categoriesList.filter((function (wc) {
						return workBonData[0].categorie == wc.id
					}))
					var roomsData = roomsList.filter((function (k) {
						return workBonData[0].kamer == k.id
					}))

					var msgtext = '';

					if (workBonData[0].msgtext != null && workBonData[0].msgtext != '') {
						msgtext = removePTags(workBonData[0].msgtext);
					}
					// if (fnameData.length > 0 && fnameData[0].picture != '' && fnameData[0].picture != null) {
					// 	if ((!ionic.Platform.isAndroid() && !ionic.Platform.isIOS() && !ionic.Platform.isIPad()))
					// 		upic = fnameData[0].picture;
					// 	else {
					// 		if (cordova.platformId == "browser") {
					// 			upic = fnameData[0].picture;
					// 		} else {
					// 			upic = toolsService.getFilePath(fnameData[0].picture);
					// 		}
					// 	}
					// }
					// else {
					// 	upic = 'img/avatar.jpg';

					let upic = fnameData[0].picture
					// }

					var foundwerkbon = {
						id: workBonData[0].id,
						fname: (fnameData.length > 0) ? fnameData[0].fname : "",
						userpicture: upic,
						werkbonseq: workBonData[0].werkbonseq,
						werkbontype: (workBonTypeData.length > 0) ? workBonTypeData[0].name : "",
						werkbonid: (workBonTypeData.length > 0) ? workBonTypeData[0].id : "",
						datecreated: workBonData[0].datecreated,
						fdatecreated: formatDate(workBonData[0].datecreated),
						msgtext: msgtext,
						// classname: workBonData[0].classname,
						categorie: (categorieData.length > 0) ? categorieData[0].name : "",
						categorieid: (categorieData.length > 0) ? categorieData[0].id : "",
						afdeling: (afdelingenData.length > 0) ? afdelingenData[0].name : "",
						afdelingid: (afdelingenData.length > 0) ? afdelingenData[0].id : "",
						kamer: (roomsData.length > 0) ? roomsData[0].name : "",
						kamerid: (roomsData.length > 0) ? roomsData[0].id : "",
						status: workBonData[0].status,
						commentaar: removePTags(workBonData[0].commentaar),
						executor: (executorData.length > 0) ? executorData[0].fname : "",
						fdateexecuted: formatDate(workBonData[0].dateexecuted),
						messageattachments: []
					};

					// var atts = Attachment.One(workBonData[0].id).then(function (atts) {
					// 	foundwerkbon.messageattachments = atts;
					// 	deferred.resolve(foundwerkbon);
					// });
					resolve(foundwerkbon)
				}
				else {
					resolve({})
				}


			}).catch((e) => reject(e));

		})

	}

	addTask(task: Tasks) {

		return new Promise((resolve, reject) => {

			this.db.tasks.add(task).then((data) => {

				if (this.connection.isOnline()) {
					setTimeout(() => {
						this.syncTasksObservable$.next(true);
					}, 1500);
				} else {
					this.showSyncTasksError$.next(true);
				}

				resolve(data);

			}).catch((e) => {

				console.log(e);
				reject(e);

			})

		})

	}

	addTaskWhenAddedAttachments(tasks: Tasks) {

		return new Promise((resolve, reject) => {

			this.db.tasks.add(tasks).then((data) => {

				resolve(data);

			}).catch((e) => {

				reject(e);

			});

		})

	}

	updateTask(id, item: Tasks) {

		return new Promise((resolve, reject) => {
			this.db.tasks.update(id, item).then((res) => {

				setTimeout(() => {
					this.syncTasksObservable$.next(true);
				}, 1500);

				resolve(res);
			}).catch((e) => {
				console.log(e);
				reject(e);
			})
		})

	}

	markTask(id, item: Tasks) {

		return new Promise((resolve, reject) => {

			this.db.tasks.update(id, item).then((res) => {

				if (this.connection.isOnline()) {
					setTimeout(() => {
						this.syncTasksObservable$.next(true);
					}, 1500);
				} else {
					this.showSyncTasksError$.next(true);
				}
				
				resolve(res);
			}).catch((e) => {
				console.log(e);
				reject(e);
			})

		})

	}

	getTaskObject() {
		return {
			id: "",
			senderuserid: "",
			documentid: "",
			archive: "",
			readbefore: "",
			datecreated: "",
			readon: "",
			type: "werkbon",
			subject: "",
			msgtext: "",
			dossierid: "",
			temp: "",
			bestemmelingen: "",
			afdeling: "",
			categorie: "",
			commentaar: "",
			werkbonseq: "",
			status: "",
			dateexecuted: "",
			userexecuted: "",
			usermodified: "",
			datemodified: "",
			permissiontext: "",
			customercode: this.configDataPrvdr.getCustomerCode(),
			kamer: "",
			bewonernaam: "",
			datearchived: "",
			userarchived: "",
			werkbontype: "",
			bestemmelingenids: "",
			conversationid: "",
			attachmentids: "",
			caredocfileattachments: "",
			source: "",
			deleted: "",
			messagestatus: "",
			readalready: "",
			realbestemmelingenids: "",
			origconversationid: "",
			subtype: "",
			appstatus: ""
		}
	}

}



// WEBPACK FOOTER //
// ./src/providers/tasks-store/tasks-store.ts